<template>
  <accordion-item-fi
    v-if="catalogData?.Attributes"
    class="accordion-technical-details-fi"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Technical-Details.Label') }}
    </template>
    <template #content>
      <grid-columns-fi
        :columns="12"
        grid-class="lg:fi-grid-cols-10"
      >
        <div class="fi-col-span-full md:fi-col-span-6 lg:fi-col-span-5">
          <technical-details-table-fi
            v-if="catalogData"
            :item="{ catalogProductData: catalogData }"
          />
        </div>

        <div
          class="accordion-technical-details-fi__image-wrapper fi-col-span-full md:fi-col-span-6 lg:fi-col-span-5"
        >
          <div
            v-if="technicalDrawing"
            class="accordion-technical-details-fi__image"
          >
            <cloud-image-fi
              :src="technicalDrawing.Url"
              alt=""
              width="400"
              do-not-replace-url
            />
          </div>
        </div>
      </grid-columns-fi>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi, CloudImageFi } from 'atoms';
import GridColumnsFi from 'components/grid-fi/GridColumnsFi';
import TechnicalDetailsTableFi from 'components/shop-modules/technical-details-table-fi/TechnicalDetailsTableFi';

export default {
  name: 'AccordionTechnicalDetailsFi',
  components: {
    AccordionItemFi,
    CloudImageFi,
    GridColumnsFi,
    TechnicalDetailsTableFi,
  },
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    technicalDrawing() {
      return this.catalogData?.Media?.find(
        (media) => media.OutputType === 'PR' && media.Type === 'Technical Drawing',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import './accordion-technical-details-fi.scss';
</style>
